import { render, staticRenderFns } from "./PricingModal.vue?vue&type=template&id=40c278ee&scoped=true&"
import script from "./PricingModal.vue?vue&type=script&lang=ts&"
export * from "./PricingModal.vue?vue&type=script&lang=ts&"
import style0 from "./PricingModal.vue?vue&type=style&index=0&id=40c278ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c278ee",
  null
  
)

export default component.exports